import { Link as RouterLink } from "react-router-dom";

// material-ui
import Link from "@mui/material/Link";

// project imports
import PlateLogo from "shared/ui/svg-images/PlateLogo";
//utils
import { getInitialPage } from "routes/utils";


const LogoSection = () => (
  <Link component={RouterLink} to={getInitialPage()} aria-label='theme-logo'>
    <PlateLogo />
  </Link>
);

export default LogoSection;
